import { ALL_ENDPOINTS } from '../constants/endpoints.constant';

export default class Environment {
  public static validLocations = ['production', 'test', 'prf', 'development', 'local'];
  public static location = 'production';
  public static getEnvironment() {
    return ALL_ENDPOINTS[`${Environment.location.toUpperCase()}_DATA_ENDPOINT`];
  }
  public static setLocation(environmentLocation: string) {
    const envAfterConvert = Environment.convertProdVariants(environmentLocation.toLowerCase());
    if (Environment.validLocations.includes(envAfterConvert)) {
      Environment.location = envAfterConvert;
    } else {
      throw new Error(`Invalid Environment location provided: ${environmentLocation}`);
    }
  }
  private static productionVariants = ['prod', 'prd', 'production'];
  private static convertProdVariants(environment: string) {
    return Environment.productionVariants.includes(environment.toLowerCase()) ? 'production' : environment;
  }
}
